<ng-container *ngIf="subscription">
  <div class="subscription-breakdown">
    <!-- Subscription with quantity of listings -->
    <div *ngIf="subscription.plan as plan" class="subscription-breakdown-item">
      <strong>{{ plan.next_amount?.formatted_string || plan.current_amount?.formatted_string }}</strong>
      <div>Subscription for {{ plan.quantity }} active properties</div>
    </div>

    <!-- Direct addon -->
    <ng-container *ngIf="subscription.addons | findDirectAddon as direct">
      <div class="subscription-breakdown-item">
        <strong>{{ direct.amount }}</strong>
        <div>for {{ direct.count }} Direct properties</div>
      </div>
    </ng-container>

    <!-- Smart devices addon -->
    <ng-container *ngIf="subscription.addons | findSmartDevicesAddon as smartDevices">
      <div class="subscription-breakdown-item">
        <strong>{{ smartDevices.amount }}</strong>
        <div>for {{ smartDevices.count }} smart devices</div>
      </div>
    </ng-container>

    <!-- Priority Support addon -->
    <ng-container *ngIf="subscription.addons | findBasePrioritySupportAddon as prioritySupport">
      <div class="subscription-breakdown-item">
        <strong>{{ prioritySupport.amount }}</strong>
        <div>Priority Support for {{ prioritySupport.count }} active properties</div>
      </div>
    </ng-container>

    <!-- Verification addons -->
    <ng-container *ngIf="subscription.addons | findVerificationAddons as verifications">
      <div *ngFor="let verification of verifications" class="subscription-breakdown-item">
        <strong>{{ verification.amount }}</strong>
        <div>{{ verification.description }} for {{ verification.count }} guests</div>
      </div>
    </ng-container>

    <!-- Discounts -->
    <ng-container *ngIf="subscription.discounts as discounts">
      <div *ngFor="let discount of discounts" class="subscription-breakdown-item italic">
        <strong></strong>
        <div>Includes {{ discount.amount }} discount for {{ discount.description }}</div>
      </div>
    </ng-container>

    <!-- Taxes -->
    <ng-container *ngIf="subscription.taxes as taxes">
      <div *ngFor="let tax of taxes" class="subscription-breakdown-item italic">
        <strong></strong>
        <div>Includes {{ tax.amount }} {{ tax.name }} in {{ subscription.country }}</div>
      </div>
    </ng-container>

    <!-- Credits -->
    <ng-container *ngIf="subscription.credits as credits">
      <div class="subscription-breakdown-item italic">
        <strong></strong>
        <div>{{ credits.formatted_string }} of credits will be applied</div>
      </div>
    </ng-container>
  </div>
</ng-container>
